export const TAX_SUMMARY_LINK =
  'https://helpcenter.soraban.com/how-to-add-tax-summary-to-tax-return';
export const DELIVERY_DRAFT_LINK =
  'https://helpcenter.soraban.com/how-to-send-a-draft-tax-return-to-a-client-for-review';
export const BULK_UPLOAD_PROCESSOR_LINK =
  'https://helpcenter.soraban.com/how-to-use-the-bulk-upload-processor-1';
